import React, { Fragment, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import panelDefinition from '../../definitions/touchPanel/touchPanel_lecc_03_01_CATIZ.json';
import { listenInTab_AC } from '../../store/actions/executor.actions';
import { ButtonArrayDict, ButtonItemDict } from '../../types/TouchPanelDefs';
import ButtonPanel from './ButtonPanel';

const StyledTouchPanel = styled.div`
  background: ${({ theme }) => theme.player.main.primary};
  position: absolute;
  height: 100%;
  width: 100%;
  font-family: 'Barlow-Regular';
`;
const TouchPanel: React.FC = () => {
  const panelDef = panelDefinition;
  const buttonPanels = panelDefinition.buttonPanels;
  const audioRef = useRef(null);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(listenInTab_AC());
  }, []);
  const buttonArrays: ButtonArrayDict = panelDefinition.buttonArrays.reduce(
    (prev: any, next: any) => {
      prev[next.id] = next;
      return prev;
    },
    {}
  );
  const buttons: ButtonItemDict = panelDefinition.buttons.reduce(
    (prev: any, next: any) => {
      prev[next.id] = next;
      return prev;
    },
    {}
  );
  const playSound = () => {
    if (audioRef.current !== null) {
      (audioRef?.current as any).play();
    }
  };
  console.log(panelDef);
  return (
    <Fragment>
      <StyledTouchPanel id="touchPanel">
        {buttonPanels.map((bp) => (
          <ButtonPanel
            key={bp.id}
            btnArrayDict={buttonArrays}
            btnDict={buttons}
            playSound={playSound}
            {...bp}
          />
        ))}
      </StyledTouchPanel>
      <audio
        ref={audioRef}
        src={require('../../assets/audio/click.mp3')}
      ></audio>
    </Fragment>
  );
};

export default TouchPanel;
